/**
 * Creative Studio shared constants.
 *
 * Single source for values that show up in more than one Creative
 * Studio component (caps used by RefinementPanel + ImagePreview,
 * marker colors used by MarkerOverlay + RefinementPanel + the backend
 * prompt). Pulling them here prevents the silent-drift class of bug
 * where one site is updated and the others aren't.
 *
 * Mirrors backend constants in `src/api/services/gemini_image_service.py`
 * — the FE/BE pair has to be kept in sync by hand because the two
 * codebases can't share a module. Backend names:
 *   MAX_REFINEMENT_LOGICAL_REFS  → MAX_REFINEMENT_REFERENCES (here)
 *   MAX_REFINEMENT_MARKS         → MAX_REFINEMENT_MARKS (here)
 *   MARKER_YELLOW_HEX            → MARKER_YELLOW_HEX (here)
 *   MARKER_MAGENTA_HEX           → MARKER_MAGENTA_HEX (here)
 */

/** Total logical references a refinement session can carry. Marks
 *  count as one logical ref each. */
export const MAX_REFINEMENT_REFERENCES = 10;

/** Marks-specific cap (within MAX_REFINEMENT_REFERENCES). Capped
 *  tighter than total refs because each mark sends two image slots
 *  to Gemini (composite + stroke-only); see the slot math in
 *  gemini_image_service.py for the 3×2 + 7 + 1 = 14 derivation. */
export const MAX_REFINEMENT_MARKS = 3;

/** Highlighter yellow — auto-picked by MarkerOverlay's brightness
 *  sampling for dark image regions. Also used by RefinementPanel's
 *  mark-badge swatch and referenced by hex in the backend prompt. */
export const MARKER_YELLOW_HEX = '#ffeb3b';

/** Highlighter magenta — auto-picked for light image regions. Same
 *  multi-site usage as MARKER_YELLOW_HEX. */
export const MARKER_MAGENTA_HEX = '#ff2e88';
